import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { parsePrice, PriceFormats, SummaryColumns, MinAvgMaxKeys } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateStructure, ValueCell } from "@tools";

export const CompanyCostCell = observer(({
  element,
  displayCellContent,
  ...props
}) => {
  const { allowEdition } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const { showFixedDecimalPrices } = structure;
  const { currencyObj, roundPrice, priceFormat, maxValuesAsBuffer } = structure.settings;
  const { displayCompanyCost, displayCompanyCostMax, showMaxCompanyCost, hasFixedPrice } = element;

  const handleCompanyCostChange = (cost, isMax) => {
    let key = MinAvgMaxKeys.AVG;
    if(isMax)
      key = MinAvgMaxKeys.MAX;
    else if(!maxValuesAsBuffer && showMaxCompanyCost)
      key = MinAvgMaxKeys.MIN;
    
    element.setCompanyCost(cost, key);
  };
  
  return (
    <ValueCell
      colName={ SummaryColumns.C_COST }
      useDynamicWidth
      fullWidthInputs
      displayContent={displayCellContent}
      value={displayCompanyCost}
      valueMax={displayCompanyCostMax}
      displayMax={showMaxCompanyCost}
      onValueChange={handleCompanyCostChange}
      editable={allowEdition && hasFixedPrice}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      max={10000000}
      parser={parsePrice}
      inputClassName="input-company-cost"
      applySuffixSpacing
      { ...props }
    />
  );
});

CompanyCostCell.propTypes = {
  element: object.isRequired,
  displayCellContent: bool,
  extendPadding: bool,
};
